/**
 * Le tableau a redessiner reste-t-il valable ? Vrai pendant toute la manche de
 * dessin, marge de collecte comprise.
 */
export function keepsAssignment(phase) {
    return phase === 'DRAWING' || phase === 'COLLECTING';
}
/** Le tableau a deviner reste-t-il valable ? */
export function keepsGuessTarget(phase) {
    return phase === 'GUESSING';
}
/**
 * La chasse du battle royale reste-t-elle affichee ?
 *
 * Elle survit a la revelation, contrairement a une cible ordinaire : le tableau
 * commun avec toutes les retouches EST le resume de la manche, on le fige au
 * lieu d'en construire un autre.
 */
export function keepsHunt(phase) {
    return phase === 'GUESSING' || phase === 'REVEAL';
}
//# sourceMappingURL=phase.js.map